module.exports = __webpack_public_path__ + "img/img_title2@2x.5b719f0d.png";